<template>
  <div class="inner-content">
    <div class="b-gray-1 filter-wrp m-t-md m-b-20">
      {{/** 分类 */}}
      <div class="clearfix">
        <div class="gray-4 pull-left">分类：</div>
        <div class="filter-content b-between">
          <span :class="{'filter-tag' : true, 'active': c.active}" v-for="c in categories" @click="clickCategory(c)" >{{c && c.name}}</span>
        </div>
      </div>
      {{/** 类别 */}}
      <div class="clearfix">
        <div class="gray-4 pull-left">类别：</div>
        <div class="filter-content">
          <span :class="{'filter-tag': true, 'active': index === activeTypeIndex}" @click="clickCaseType(index)" v-for="(c,index) in types" >{{c}}</span>
        </div>
      </div>
    </div>
    {{/** 价格 */}}
    <div class="price-wrp">
      <template v-for="(o, index) in orderTypes">
        <span :class="{'order-tag': true, 'active': index === condition.order_type}" @click="clickOrderType(index)">{{o}}</span>|
      </template>
      <input class="price-filter price-input m-l-md" type="text" v-model="condition.price_min"></input> - <input
        class="price-filter price-input" type="text" v-model="condition.price_max"></input>
      <span class="price-vrf-btn price-filter" @click="choosePriceRange()">确定</span>
      {{/** price btn group */}}
      <span class="price-filter" :class="{'price-btn': true, 'active': p.active}" v-for="(p, index) in priceTags" @click="choosePriceTag(index)">{{p.name}}</span>
    </div>
    {{/** 地区 */}}
    <div class="b-gray-1 filter-wrp m-b-md" style="margin-top: -1px;">
      <label><input type="checkbox" v-model="isPromotion"> 正在促销</label>
      <label><input type="checkbox" v-model="hasVideo"> 包含视频</label>
      <div class="po-r m-l-md region-btn" role="button">{{city && city.name}} <i class="fa fa-angle-down" />
      {{/** region selector */}}
      <div class="region-selector">
        <div class="allRegion-tag" @click="chooseNonCity()">全国</div>
        <hr>
        <div class="region-title">热门城市</div>
        <div class="region-tag-wrp">
          <span v-for="c in hotCities" class="region-tag" @click="chooseHotCity(c)">{{c && c.cityName}}</span>
        </div>
        <hr>
        <div class="region-title">其他城市</div>
        <div style="margin-top: 10px">
          <div class="pull-right" style="margin-top: 7px;">
            <div class="c-b c-b-primary pull-right text-center clickCityConfirm" @click="clickCityConfirm()"><span>确定</span></div>
          </div>
          <select class="form-input" v-model="province">
            <option v-for="op in provinces" :value="op">{{op.name}}</option>
          </select>
          <select class="form-input m-l-lg" v-model="city">
            <option v-for="(city,index) in cities" :value="city">{{city.name}}</option>
          </select>
        </div>
      </div>
      </div>
    </div>
    {{/** content*/}}
    <div class="clearfix m-t-md c-3-1-wrp">
      <div class="c-3-1-wrp clearfix" v-if="cases.length" v-for="s in Math.ceil(cases.length / 3)">
        <div class="c-3-1 m-b-md b-gray-1 hp-item-6" v-for="c in sthItems(s)" @click="gotoCase(c.id)">
          {{/** use background for image */}}
          <div class="m-a img-c-div h-44" v-bind:style='{backgroundImage: "url("+c.coverImgUrl+")"}'>
          </div>
          <div class="collect-heat text-center" v-if="c.isFavored" @click.stop="unFavorCaseInfo(c)">
            <i class="fa fa-heart heart-pink"/>
            <span class="gray-1 text-medium">{{c.favorNum}}</span>
          </div>
          <div class="collect-heat text-center"  v-if="!c.isFavored" @click.stop="favorCaseInfo(c)">
            <i class="fa fa-heart-o gray-1" />
            <span class="gray-1 text-medium">{{c.favorNum}}</span>
          </div>
          <div class="m-a b-gray-1 p-a h-p-item-c">
            <!--<div class="text-price m-b-md">¥{{c.sellPrice/100}}</div>-->
            <div class="m-b-15 text-elli">
              <span class="f-6"><span>{{c.shopInfo && c.shopInfo.cityName ? c.shopInfo && c.shopInfo.cityName : '北京'}}</span>｜{{c.title}}</span>
              <span>-</span>
              <span class="f-7" v-if="(c.shopInfo&&c.shopInfo.name) !== null && (c.shopInfo&&c.shopInfo.name) !==undefined">{{c.shopInfo && c.shopInfo.name}}</span>
            </div>
            <div class="gray-1 text-small">
              <!--<div class="text-elli">{{c.title}}</div>-->
              <div class="text-elli">{{c.description}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hint" v-if="showHint">{{hintMsg}}</div>
    <pagination :pagination="pagination" :callback="loadData" :options="paginationOptions"></pagination>
  </div>
</template>
<script>

import miniToastr from 'mini-toastr';
import pagination from '../reusable/Pagination';
import { mixinPager } from '../reusable/pager';
import apiHelper from '../service/apiHelper';
import cmService from '../service/common';
import bus from '../utils/bus';
import uService from '../service/user';

const vm = {
  name: 'List',
  mainService: apiHelper,
  service: 'searchCase',
  dataKey: 'cases',
  forbidInitalReload: true,
  data() {
    return {
      cases: [],
      categories: [],
      types: ['全部', '服务案例', '实体商品'],
      orderTypes: ['当前最热', '价格最低', '价格最高', '最新发布'],
      showHint: false,
      hintMsg: '没有相关案例信息',
      priceTags: [
        { name: '十万以下', priceMin: undefined, priceMax: 100000, active: false },
        { name: '10-30万', priceMin: 100000, priceMax: 300000, active: false },
        { name: '30-50万', priceMin: 300000, priceMax: 500000, active: false },
        { name: '50万以上', priceMin: 500000, priceMax: undefined, active: false },
      ],
      provinces: [],
      allCities: [],
      hotCities: [],
      province: undefined,
      city: undefined,
      activeTypeIndex: 0,
      isPromotion: false,
      hasVideo: false,
      condition: {
        order_type: 0,
        price_min: undefined,
        price_max: undefined,
        keywords: undefined,
      },
    };
  },
  created() {
    console.log('list created');
    this.pagination.per_page = 12;
    bus.$on('SEARCH_CHANGED', () => {
      this.condition.keywords = this.$route.query.keyword;
      this.reload();
    });

    cmService.locs().then((resp) => {
      this.provinces = resp.provinces || [];
      this.allCities = resp.cities || [];
      this.hotCities = resp.hotCities || [];
      this.categories = resp.categories || [];
//     init category
      this.categories.forEach((c) => {
        this.$set(c, 'active', false);
      });
//     init province & city
      if (this.provinces[0].id !== -1) {
        this.provinces.splice(0, 0, {
          id: -1,
          name: '全国',
        });
      }
      if (this.allCities[0].id !== -1) {
        this.allCities.splice(0, 0, {
          id: -1,
          provinceId: -1,
          name: '全国',
        });
      }
      this.province = this.provinces[0];
      this.city = this.allCities[0];

//    init search condition and do load
      this.condition.keywords = this.$route.query.keyword;
      if (this.$route.query.categoryId >= 0) {
        this.categories.forEach((_c) => {
          const c = _c;
          if (Number(_c.id) === Number(this.$route.query.categoryId)) {
            c.active = true;
          }
        });
      }
      if (this.$route.query.hasVideo === '1') {
        this.hasVideo = true;
      }

      this.reload();
    }, (resp) => {
      miniToastr.error(resp.msg, '获取城市列表失败');
    });
  },
  components: {
    pagination,
  },
  methods: {
    gotoCase(id) {
      this.$router.push({ name: 'CaseDetail', params: { id } });
    },
    clickCategory(_c) {
      const c = _c;
      c.active = !c.active;
      this.reload();
    },
    clickCaseType(index) {
      this.activeTypeIndex = index;
      this.reload();
    },
    clickOrderType(index) {
      this.condition.order_type = index;
      this.reload();
    },
    choosePriceRange() {
      this.priceTags.forEach((_p) => {
        const p = _p;
        p.active = false;
      });
      this.reload();
    },
    choosePriceTag(index) {
      this.priceTags.forEach((_p) => {
        const p = _p;
        p.active = false;
      });
      this.priceTags[index].active = true;
      this.condition.price_min = this.priceTags[index].priceMin;
      this.condition.price_max = this.priceTags[index].priceMax;
      this.reload();
    },
    clickIsPromotion() {
      this.reload();
    },
    clickHasVideo() {
      this.reload();
    },
    chooseNonCity() {
      this.province = this.provinces[0];
      this.city = this.allCities[0];
    },
    chooseHotCity(hotCity) {
      this.city = this.allCities.filter(c => c.id === hotCity.cityId)[0];
      this.province = this.provinces.filter(p => p.id === this.city.provinceId)[0];
    },
    clickCityConfirm() {
      this.reload();
    },
    favorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        miniToastr.error('请登录后收藏');
        return;
      }
      apiHelper.favorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', true);
        const newFavorNum = caseInfo.favorNum + 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
    unFavorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        miniToastr.error('请登录后取消收藏');
        return;
      }
      apiHelper.unFavorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', false);
        const newFavorNum = caseInfo.favorNum - 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
    reload() {
      this.condition.category_id_array = [];
      this.categories.forEach((c) => {
        if (c.active) {
          this.condition.category_id_array.push(c.id);
        }
      });

      if (this.city && this.city.id >= 0) {
        this.condition.city_id = this.city.id;
      } else {
        this.condition.city_id = undefined;
      }

      if (this.isPromotion === true) {
        this.condition.is_promotion = 2;
      } else {
        this.condition.is_promotion = undefined;
      }

      if (this.hasVideo === true) {
        this.condition.has_video = 2;
      } else {
        this.condition.has_video = undefined;
      }

      if (this.activeTypeIndex === 0) {
        this.condition.case_type = undefined;
      } else if (this.activeTypeIndex === 1) {
        this.condition.case_type = 1;
      } else {
        this.condition.case_type = 2;
      }

      this.pagination.current_page = 1;
//      this.cases = [];
      this.showHint = false;

      this.loadData();
    },
    sthItems(s) {
      return this.cases.filter((c, index) => index >= (s - 1) * 3 && index < s * 3);
    },
  },
  computed: {
    cities() {
      const curProvinceId = this.province === undefined ? -1 : this.province.id;
      return this.allCities.filter(c => c.provinceId === curProvinceId);
    },
  },
  watch: {
    cases: {
      handler(list) {
        if (list.length === 0) {
          this.showHint = true;
        } else {
          this.showHint = false;
        }
      },
      deep: true,
    },
    isPromotion: {
      handler() {
        this.clickIsPromotion();
      },
    },
    hasVideo: {
      handler() {
        this.clickHasVideo();
      },
    },
  },
};

mixinPager(vm);

export default vm;

</script>
<style>
.filter-content {
  margin-left: 63px;
  border-bottom: 1px solid #f8f8f8;
}
.b-between {
  background: url(../assets/border-bottom.png) repeat;
}
.filter-wrp {
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f8f8f8;
  font-size: 14px;
  line-height: 44px;
  vertical-align: middle;
  color: #252525;
  font-weight: 300;
}
.filter-tag {
  display: inline-block;
  width: 76px;
	height: 24px;
	border: solid 0.5px #a9a9a9;
  vertical-align: middle;
  line-height: 24px;
  text-align: center;
  margin-right: 24px;
  cursor: pointer;
}
.filter-tag:hover {
  background-color: #e1e1e1;
}
.filter-tag.active {
  border: solid 0.5px #ba882a;
  color: #ba882a;
  background-color: transparent;
}
.price-wrp {
  height: 40px;
  line-height: 40px;
  border: solid 0.5px #e1e1e1;
  vertical-align: middle;
  font-weight: 300;
  font-size: 14px;
}
.order-tag {
  margin: 0 20px;
  cursor: pointer;
}
.order-tag:hover {
  color: #ba882a;
}
.order-tag.active {
  color: #ba882a;
}
.price-filter {
  font-size: 12px;
  color: #525252;
  line-height: 24px;
  height: 24px;
  display: inline-block;
  padding: 0 12px;
}
.price-vrf-btn {
  margin: 0 10px;
  border: solid 1px #dadada;
  text-align: center;
  cursor: pointer;
}
.price-input {
  padding: 0 5px;
  width: 48px;
}
.price-btn {
  border: solid 1px #dadada;
  cursor: pointer;
}
.price-btn:hover {
  border: solid 1px #ba882a;
  color: #ba882a;
}
.price-btn.active {
  border: solid 1px #ba882a;
  color: #ba882a;
}
.price-2nd-btn {
  border: solid 1px #dadada;
  border-left: 0 none;
  cursor: pointer;
}
.region-btn {
  display: inline-block;
  height: 44px;
  padding: 0 15px;
  /*box-sizing: border-box;*/
  border: solid 0.5px transparent;
}
.region-btn:hover {
  border: solid 1px #a9a9a9;
  background-color: #fff;
}
.region-title {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
  color: #656565;
}
.region-selector {
  position: absolute;
  width: 324px;
  background-color: #fff;
  border: solid 1px #a9a9a9;
  left: -1px;
  top: 43px;
  cursor: default;
  padding: 15px;
}
.region-selector::before {
  position: absolute;
  top: -1px;
  height: 1px;
  width: 71px;
  background-color: #fff;
  content: '';
  left: 0;
}
.region-tag-wrp {
  margin-right: -30px;
  height: 3rem;
}
.region-tag-wrp > span {
  margin-right: 30px;
  font-size: 12px;
	font-weight: 300;
  line-height: 20px;
}
.allRegion-tag {
  color: #252525;
}
.allRegion-tag:hover {
  color: #ba882a;
}
.region-tag {
  float:left;
}
.region-tag:hover {
  color: #ba882a;
}
.region-selector {
  display: none;
}
.region-btn:hover .region-selector {
  display: block;
}
.collect-heat {
  height: 25px;
  width: 60px;
  background-color: rgba(255,255,255,0.7);
  line-height: 25px;
  float: right;
  margin-top: -40px;
  margin-right: 25px;
  cursor: pointer;
}
.clickCityConfirm{
  line-height: 30px;
}
/*select {*/
  /*visibility:hidden;*/
/*}*/
.m-b-15 {
  /*margin-top: 10px;*/
  margin-bottom: 15px;
}
.f-6 {
  font-size: 16px;
  color: #525252;
  font-weight: bold;
}
.f-7{
  font-size: 16px;
  color: #787878;
  font-weight: lighter;
}
</style>



// WEBPACK FOOTER //
// List.vue?5299221e